import { useCallback, useEffect, useState } from "react";
import {
  FaTimes,
  FaSignOutAlt,
  FaHeadset,
  FaUsers,
  FaRupeeSign,
  FaImages,
  FaCog,
  FaShoppingCart,
  FaQrcode,
  FaChartLine,
} from "react-icons/fa";
import { RiLuggageDepositFill } from "react-icons/ri";

import {
  FiHome,
  FiShield,
  FiChevronDown,
  FiChevronRight,

  // FiSettings,
} from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { onErrorLogout } from "../_config/authService";
import removebg from "../assets/removebg.svg";
import logout from "../assets/icons/logout.svg";
import { makeRequestAuth } from "../_config/api";

export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [dotSummary, setDotSummary] = useState({});

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const fetchDotSummary = useCallback(async () => {
    try {
      const response = await makeRequestAuth("get", "/admin/getDotSummary");

      setDotSummary(response?.data || {});
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    fetchDotSummary();
  }, [fetchDotSummary]);

  const updateDotStatus = async (type, subType = null) => {
    try {
      await makeRequestAuth("post", "/admin/updateDotStatus", {
        type,
        subType,
      });

      // refresh counts
      fetchDotSummary();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 lg:hidden"
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-72
        bg-gradient-to-b from-white via-gray-50 to-white
        dark:from-gray-900 dark:via-gray-800 dark:to-gray-900
        flex flex-col z-40 
        border-r border-gray-200 dark:border-gray-700
        transition-transform duration-300 ease-in-out
        ${sidebarOpen ? "translate-x-0 shadow-2xl" : "-translate-x-full lg:translate-x-0"}`}
      >
        {/* Logo Section */}
        <div className="relative py-2 px-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-center gap-3">
            <div className="relative">
              <img
                src={removebg}
                alt="logo"
                className="mx-auto h-[56px] w-auto
                bg-gradient-to-r from-blue-600 to-purple-600 
                hover:from-blue-700 hover:to-purple-700 
                shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 
                rounded-xl p-3 dark:bg-transparent dark:shadow-none"
              />
            </div>
          </div>

          <button
            className="lg:hidden absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
            onClick={() => setSidebarOpen(false)}
          >
            <FaTimes className="text-gray-700 dark:text-gray-300" size={18} />
          </button>
        </div>

        {/* Navigation Menu */}
        <div className="flex-1 overflow-y-auto px-4 py-6 space-y-2 custom-scrollbar">
          <div className="mb-4">
            <MenuItem
              to="/"
              icon={<FiHome size={20} />}
              label="Dashboard"
              setSidebarOpen={setSidebarOpen}
            />
          </div>
          <SectionTitle title="Users" />
          <MenuItem
            to="/users"
            icon={<FaUsers size={20} />}
            label="All User"
            setSidebarOpen={setSidebarOpen}
          />
          <MenuItem
            to="/qr-code"
            icon={<FaQrcode size={20} />}
            label="All QR Code"
            setSidebarOpen={setSidebarOpen}
          />

          {/* QR Code Section */}
          <div className="space-y-1">
            <button
              onClick={() => toggleMenu("deposit")}
              className="flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <div className="flex items-center gap-3 text-gray-700 dark:text-gray-300">
                <div className="relative">
                  <RiLuggageDepositFill
                    size={18}
                    className="text-blue-600 dark:text-blue-400"
                  />

                  {(dotSummary?.DEPOSIT?.USDT || 0) +
                    (dotSummary?.DEPOSIT?.TOKEN || 0) >
                    0 && (
                    <span className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center">
                      {(dotSummary?.DEPOSIT?.USDT || 0) +
                        (dotSummary?.DEPOSIT?.TOKEN || 0)}
                    </span>
                  )}
                </div>

                <span className="font-semibold">Deposit</span>
              </div>

              <div className="text-gray-500">
                {openMenu === "deposit" ? (
                  <FiChevronDown />
                ) : (
                  <FiChevronRight />
                )}
              </div>
            </button>

            {openMenu === "deposit" && (
              <div className="ml-4 pl-2 border-l-2 border-gray-100 dark:border-gray-700 space-y-1 animate-fadeIn">
                <MenuItem
                  to="/deposit/usdt"
                  label="Usdt"
                  count={dotSummary?.DEPOSIT?.USDT || 0}
                  setSidebarOpen={setSidebarOpen}
                  onClick={() => updateDotStatus("DEPOSIT", "USDT")}
                />
                <MenuItem
                  to="/deposit/token"
                  label="Token"
                  count={dotSummary?.DEPOSIT?.TOKEN || 0}
                  setSidebarOpen={setSidebarOpen}
                  onClick={() => updateDotStatus("DEPOSIT", "TOKEN")}
                />
              </div>
            )}
          </div>

          <MenuItem
            to="/buy-inr"
            icon={<FaRupeeSign size={20} />}
            label="Buy Inr"
            setSidebarOpen={setSidebarOpen}
          />

          {/* P2P Section Management */}
          <div className="space-y-1">
            <button
              onClick={() => toggleMenu("p2pmangement")}
              className="flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <div className="flex items-center gap-3 text-gray-700 dark:text-gray-300 min-w-0">
                <div className="relative">
                  <FiShield
                    size={18}
                    className="text-blue-600 dark:text-blue-400 shrink-0"
                  />

                  {(dotSummary?.P2P?.BUY || 0) + (dotSummary?.P2P?.SELL || 0) >
                    0 && (
                    <span className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center">
                      {(dotSummary?.P2P?.BUY || 0) +
                        (dotSummary?.P2P?.SELL || 0)}
                    </span>
                  )}
                </div>

                <span className="font-semibold text-[15px] truncate">
                  P2P Orders Management
                </span>
              </div>

              <div className="text-gray-500 shrink-0 ml-2">
                {openMenu === "p2pmangement" ? (
                  <FiChevronDown />
                ) : (
                  <FiChevronRight />
                )}
              </div>
            </button>

            {openMenu === "p2pmangement" && (
              <div className="ml-4 pl-2 border-l-2 border-gray-100 dark:border-gray-700 space-y-1 animate-fadeIn">
                <MenuItem
                  to="/p2p/buy-order-list"
                  label="Buy Orders List"
                  count={dotSummary?.P2P?.BUY || 0}
                  setSidebarOpen={setSidebarOpen}
                  onClick={() => updateDotStatus("P2P", "BUY")}
                />
                <MenuItem
                  to="/p2p/sell-order-list"
                  label="Sell Orders List"
                  count={dotSummary?.P2P?.SELL || 0}
                  setSidebarOpen={setSidebarOpen}
                  onClick={() => updateDotStatus("P2P", "SELL")}
                />
                <MenuItem
                  to="/p2p/sell-order/create"
                  label="Create Sell Orders"
                  setSidebarOpen={setSidebarOpen}
                />
                <MenuItem
                  to="/p2p/buy-order/create"
                  label="Create Buy Orders"
                  setSidebarOpen={setSidebarOpen}
                />
              </div>
            )}
          </div>

          {/* Purana MenuItem hatakar ye SubMenu lagayein */}
          <div className="space-y-1">
            <button
              onClick={() => toggleMenu("sellManagement")}
              className="flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <div className="flex items-center gap-3 text-gray-700 dark:text-gray-300 min-w-0">
                <div className="relative">
                  <FaShoppingCart
                    size={18}
                    className="text-blue-600 dark:text-blue-400 shrink-0"
                  />

                  {(dotSummary?.SELL?.USDT || 0) +
                    (dotSummary?.SELL?.TOKEN || 0) >
                    0 && (
                    <span className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center">
                      {(dotSummary?.SELL?.USDT || 0) +
                        (dotSummary?.SELL?.TOKEN || 0)}
                    </span>
                  )}
                </div>

                <span className="font-semibold text-[15px] truncate">
                  Sell Management
                </span>
              </div>

              <div className="text-gray-500 shrink-0 ml-2">
                {openMenu === "sellManagement" ? (
                  <FiChevronDown />
                ) : (
                  <FiChevronRight />
                )}
              </div>
            </button>

            {openMenu === "sellManagement" && (
              <div className="ml-4 pl-2 border-l-2 border-gray-100 dark:border-gray-700 space-y-1 animate-fadeIn">
                <MenuItem
                  to="/sells/usdt"
                  label="USDT Sells"
                  count={dotSummary?.SELL?.USDT || 0}
                  setSidebarOpen={setSidebarOpen}
                  onClick={() => updateDotStatus("SELL", "USDT")}
                />
                <MenuItem
                  to="/sells/token"
                  label="TOKEN Sells"
                  count={dotSummary?.SELL?.TOKEN || 0}
                  setSidebarOpen={setSidebarOpen}
                  onClick={() => updateDotStatus("SELL", "TOKEN")}
                />
              </div>
            )}
          </div>

          <MenuItem
            to="/banner"
            icon={<FaImages size={20} />}
            label="Banner"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/app-settings"
            icon={<FaCog size={20} />}
            label="App Settings"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/agent-ship"
            icon={<FaChartLine size={20} />}
            label="Agent Ship"
            count={dotSummary?.AGENTSHIP || 0}
            setSidebarOpen={setSidebarOpen}
            onClick={() => updateDotStatus("AGENTSHIP")}
          />

          <MenuItem
            to="/support-tickets"
            icon={<FaHeadset size={20} />}
            label="Support"
            count={dotSummary?.TICKET || 0}
            setSidebarOpen={setSidebarOpen}
            onClick={() => updateDotStatus("TICKET")}
          />
        </div>

        {/* Logout Button */}
        <div className="border-t border-gray-200 dark:border-gray-700 p-4 bg-gray-50/50 dark:bg-gray-800/50">
          <button
            onClick={() => setShowLogoutPopup(true)}
            className="flex items-center gap-3 px-4 py-3 w-full rounded-xl
            text-red-600 dark:text-red-400 font-semibold
            hover:bg-red-50 dark:hover:bg-red-500/10 transition-all group"
          >
            <div className="w-8 h-8 rounded-lg bg-red-100 dark:bg-red-900/30 flex items-center justify-center group-hover:scale-110 transition-transform">
              <FaSignOutAlt />
            </div>
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Logout Confirmation Popup */}
      {showLogoutPopup && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[999] flex justify-center items-center p-4 animate-fadeIn">
          <div className="bg-white dark:bg-gray-800 rounded-2xl w-full max-w-md shadow-2xl overflow-hidden animate-scaleIn">
            <div className="bg-gradient-to-r from-red-500 to-pink-600 p-6 text-center">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
                <img src={logout} alt="logout" className="w-8 h-8 invert" />
              </div>
              <h2 className="text-2xl font-bold text-white">
                Logout Confirmation
              </h2>
            </div>
            <div className="p-6">
              <p className="text-gray-700 dark:text-gray-300 text-center mb-6">
                Are you sure you want to log out? <br />
                <span className="text-sm text-gray-500">
                  You will be signed out from the Admin panel.
                </span>
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowLogoutPopup(false)}
                  className="flex-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-6 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={() => onErrorLogout()}
                  className="flex-1 bg-gradient-to-r from-red-500 to-pink-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-red-500/30 transition-all"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 3px;
        }
        .dark .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #475569;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes scaleIn {
          from {
            transform: scale(0.95);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
        .animate-scaleIn {
          animation: scaleIn 0.2s ease-out;
        }
      `}</style>
    </>
  );
}

function SectionTitle({ title }) {
  return (
    <div className="px-3 mt-6 mb-2 flex items-center gap-2">
      <div className="h-px bg-gray-200 dark:border-gray-700 flex-1"></div>
      <p className="text-[10px] uppercase tracking-widest font-bold text-gray-400 dark:text-gray-500">
        {title}
      </p>
      <div className="h-px bg-gray-200 dark:border-gray-700 flex-1"></div>
    </div>
  );
}

// function MenuItem({ to, icon, label, setSidebarOpen }) {
//   const baseClass =
//     "flex items-center justify-between gap-3 px-4 py-3 rounded-xl group transition-all duration-200 my-1";

//   return (
//     <NavLink
//       to={to}
//       end
//       onClick={() => window.innerWidth < 1024 && setSidebarOpen(false)}
//       className={({ isActive }) =>
//         `${baseClass} ${
//           isActive
//             ? "bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-md"
//             : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800"
//         }`
//       }
//     >
//       {({ isActive }) => (
//         <>
//           <div className="flex items-center gap-3">
//             <div
//               className={`transition-transform duration-200 group-hover:scale-110 ${isActive ? "text-white" : "text-blue-600 dark:text-blue-400"}`}
//             >
//               {icon}
//             </div>
//             <span className="font-semibold text-[15px]">{label}</span>
//           </div>
//           <FiChevronRight
//             className={`w-4 h-4 transition-all ${isActive ? "opacity-100" : "opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0"}`}
//           />
//         </>
//       )}
//     </NavLink>
//   );
// }

function MenuItem({ to, icon, label, setSidebarOpen, count, onClick }) {
  console.log("count", count);
  const baseClass =
    "flex items-center justify-between gap-3 px-4 py-3 rounded-xl group transition-all duration-200 my-1";

  return (
    <NavLink
      to={to}
      end
      onClick={() => {
        if (onClick) {
          onClick();
        }

        if (window.innerWidth < 1024) {
          setSidebarOpen(false);
        }
      }}
      className={({ isActive }) =>
        `${baseClass} ${
          isActive
            ? "bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-md"
            : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800"
        }`
      }
    >
      {({ isActive }) => (
        <>
          <div className="flex items-center gap-3">
            <div
              className={`transition-transform duration-200 group-hover:scale-110 ${
                isActive ? "text-white" : "text-blue-600 dark:text-blue-400"
              }`}
            >
              {icon}
            </div>

            <span className="font-semibold text-[15px]">{label}</span>
          </div>

          <div className="flex items-center gap-2">
            {count > 0 && (
              <div className="min-w-[22px] h-[22px] px-1 rounded-full bg-red-500 text-white text-xs flex items-center justify-center font-bold">
                {count}
              </div>
            )}

            <FiChevronRight
              className={`w-4 h-4 transition-all ${
                isActive
                  ? "opacity-100"
                  : "opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0"
              }`}
            />
          </div>
        </>
      )}
    </NavLink>
  );
}
